import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { LinkRef } from '@kion/data-models';
import { BehaviorSubject, interval, Observable, of } from 'rxjs';
import { debounce, map } from 'rxjs/operators';
import { SubSink } from 'subsink';

export interface Checkbox {
  title: string;
  isLink: boolean;
  required: boolean;
  checked: boolean;
  linkRef?: LinkRef;
  query?: string
  titleAsHtml?: boolean
}

@Component({
  selector: 'kion-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, OnChanges, OnDestroy {

  @Input() boxes: Checkbox[];
  @Input() error: string;

  boxes$: BehaviorSubject<Checkbox[]> = new BehaviorSubject<Checkbox[]>([]);

  private subSink: SubSink;

  // tslint:disable-next-line:no-output-rename
  @Output('requiredSelected') checkRequiredBoxesCheckedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  // tslint:disable-next-line:no-output-rename
  @Output('boxToggled') boxToggledEmitter: EventEmitter<Checkbox> = new EventEmitter<Checkbox>();

  constructor() {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    this.boxes$.next(this.boxes);
    this.subSink.sink = this.subSink.sink = this.boxes$.pipe(debounce(() => interval(500)))
      .subscribe(
        (boxes: Checkbox[]) => {
          let isChecked = true;
          isChecked = !boxes.find(box => isChecked = box.required && !box.checked);
          this.checkRequiredBoxesCheckedEmitter.emit(isChecked);
        }
      )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.boxes) {
      this.boxes = changes.boxes.currentValue;
      this.boxes$.next(this.boxes);
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  toggleBox(box: Checkbox) {
    this.boxToggledEmitter.emit({
      ...box,
      checked: !box.checked
    });
    this.boxes$.next(
      this.boxes$.value.map(
        (checkbox: Checkbox) => {
          return {
            ...checkbox,
            checked: box === checkbox ? !box.checked : checkbox.checked
          }
        }
      )
    );
  }
}
